import { signalStoreFeature, withState } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { formRuleDebugEvents } from './form-rule-debug-events';

export type AdminOverride = 'db' | 'internal_admin' | 'admin' | 'none';

const nextAdminOverride: Record<AdminOverride, AdminOverride> = {
  db: 'internal_admin',
  internal_admin: 'admin',
  admin: 'none',
  none: 'db',
};

// DEV-ONLY form-rule debug. Delete this feature, withFormRuleDebugEventHandlers,
// formRuleDebugEvents and the debug block in the ReportStore withMethods to
// remove the form-rule debug UI.
// adminOverride forces the role that the isInternalAdmin and isAdmin rule
// inputs read: 'db' uses the real role, 'internal_admin' and 'admin' force
// that role, and 'none' forces no admin role. templateOverride forces which
// templates the form applies: null uses the vessel's own list, and a list asks
// the server to merge that list instead. templateNames holds every name the
// server holds, for the list the debug control offers.
export function withFormRuleDebugReducer() {
  return signalStoreFeature(
    withState({
      formDebugMode: false,
      adminOverride: 'db' as AdminOverride,
      templateOverride: null as string[] | null,
      templateNames: [] as string[],
    }),
    withReducer(
      on(formRuleDebugEvents.toggleFormDebugMode, (_, state) => ({
        formDebugMode: !state.formDebugMode,
      })),
      on(formRuleDebugEvents.cycleAdminOverride, (_, state) => ({
        adminOverride: nextAdminOverride[state.adminOverride],
      })),
      on(formRuleDebugEvents.setTemplateOverride, ({ payload: templateOverride }) => ({
        templateOverride,
      })),
      on(formRuleDebugEvents.gotTemplateNames, ({ payload: templateNames }) => ({
        templateNames,
      }))
    )
  );
}
